"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumTheme = void 0;
/**
 * User theme preference. This is a string value that can be \'light\' or \'dark\'
 */
exports.EnumTheme = {
    Light: 'light',
    Dark: 'dark',
};
//# sourceMappingURL=enum-theme.js.map